import { createContext, useContext } from 'react';

import {
  WebhookEventSubscriptionEventTriggerType,
  WebhookEventSubscriptionEventType,
} from '../utils/webhook-event-subscription-utils';

type WebhookEventSubscriptionContextType = {
  setEventType: (value: WebhookEventSubscriptionEventType | null) => void;
  setEventTriggerType: (trigger: WebhookEventSubscriptionEventTriggerType) => void;
  eventTriggerType: WebhookEventSubscriptionEventTriggerType | null;
  setSubscriptionDetail: (detail: Record<string, any>) => void;
  subscriptionDetail: Record<string, any> | null;
};

export const WebhookEventSubscriptionContext = createContext<
  WebhookEventSubscriptionContextType | undefined
>(undefined);

// Helper function to handle undefined default context and throw error in local development
// The default value (undefined) is returned if React can’t find any providers of the specific context in the parent tree,
// https://react.dev/reference/react/useContext#specifying-a-fallback-default-value
export const useWebhookEventSubscriptionContext = () => {
  const context = useContext(WebhookEventSubscriptionContext);
  if (context === undefined) {
    throw new Error(
      'useWebhookEventSubscriptionContext must be called within the WebhookEventSubscriptionContext Provider',
    );
  }

  return context;
};
